import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const PeopleSectionHeader = styled.span`
  font-size: 15px;
  font-weight: 400;
  line-height: 1.73;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
  display: flex;
  width: 100%;
`;

export const PeopleSectionManagerVisibility = styled.section`
  font-size: 15px;
  font-weight: 400;
  line-height: 1.73;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
  width: 100%;
  margin-bottom: 15px;
`;

export const PeopleSectionManagerVisibilityLabel = styled.label`
  font-size: 15px;
`

export const PeopleSectionManagerVisibilitySlider = styled.div`
  margin-left: 20px;
  margin-right: 20px;
`

export const SchedulesItemContent = styled.form`
  align-items: center;
`;

export const SchedulesItemSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 1rem 2rem;
  border-top: 7px solid ${({ theme }) => theme.black.a1};
  flex-flow: row wrap;
`;

export const HeaderContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`;

export const TopicDescription = styled.span`
  margin-left: 5px;
`;

export const ChipsError = styled.span`
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  display: block;
  align-self: center;
  margin-top: 1rem;
  justify-self: right;
  ${media.tablet`
    justify-self: left;
    margin-top: auto;
  `}
`;

export const TemplateError = styled.div`
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  padding: 0 0 1rem 1rem;
`;

export const ButtonSectionContainer = styled.div`
  align-items: center;
  padding: 1rem;
  font-size: 1rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ErrorContainer = styled.div`
  padding: 0 1rem 1rem 1rem;
  display: flex;
  justify-content: flex-end;
`;

export const ButtonMargin = styled.div`
  margin-left: 1rem;
`;

export const StatusSectionContainer = styled.div<{ $active: boolean }>`
  padding: 2.5rem;
  background-color: ${({ $active, theme }) => ($active ? theme.green.a10 : theme.lightBlue.a10)};
  transition: 0.5s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  align-items: center;
  min-height: 150px;
`;

export const PeopleSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionLine = styled.div<{ $noPadding?: boolean; $locked?: boolean }>`
  width: ${({ $locked }) => ($locked ? 'auto' : '100%')};
  padding: ${({ $noPadding }) => ($noPadding ? '0' : '15px')} 0;
`;

export const InputsSection = styled.div<{ $locked?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: ${({ $locked }) => ($locked ? 'row' : 'column')};
`;
